module.exports = __webpack_public_path__ + "static/img/kids-img-01@m.5acb6ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/kids-img-01@m.jpg
// module id = 4xUw
// module chunks = 0